module.exports = __webpack_public_path__ + "img/diamond_card.56c3833e.png";